import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { db, storage } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../css/CareerForm.css";

const JobApplicationForm = ({ jobTitle, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    qualification: "",
    experience: "",
    coverLetter: "",
  });

  const [resumeFile, setResumeFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (allowedTypes.includes(selectedFile.type)) {
        setResumeFile(selectedFile);
      } else {
        alert("कृपया केवल PDF या Word Document (.doc/.docx) फाइल ही चुनें!");
        e.target.value = "";
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resumeFile) {
      alert("कृपया अपनी रिज्यूमे फाइल अपलोड करें। (Please upload your resume)");
      return;
    }

    setSubmitting(true);

    try {
      const fileRef = ref(storage, `resumes/${Date.now()}_${resumeFile.name}`);

      const uploadResult = await uploadBytes(fileRef, resumeFile);

      const downloadUrl = await getDownloadURL(uploadResult.ref);

      await addDoc(collection(db, "applications"), {
        jobTitle: jobTitle,
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        qualification: formData.qualification,
        experience: formData.experience,
        resumeUrl: downloadUrl,
        coverLetter: formData.coverLetter,
        status: "Pending",
        appliedAt: new Date(),
      });

      alert("Success! Your application has been submitted.");
      onClose();
    } catch (err) {
      alert("Error submitting application: " + err.message);
    }
    setSubmitting(false);
  };

  return (
    <div className="form-modal-overlay">
      <div className="form-modal-card">
        <div className="form-modal-header">
          <div>
            <h2>Apply for Position</h2>
            <p className="job-badge">{jobTitle}</p>
          </div>
          <button className="btn" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="application-form">
          <div className="form-group">
            <label>
              Full Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              required
              placeholder="Enter full name"
              value={formData.fullName}
              onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>
                Email Address <span className="required">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>
                Phone Number <span className="required">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                required
                placeholder="98XXXXXXXX"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>
                Highest Qualification <span className="required">*</span>
              </label>
              <input
                type="text"
                name="qualification"
                required
                placeholder="e.g. B.Ed, MCA"
                value={formData.qualification}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>
                Experience (Years) <span className="required">*</span>
              </label>
              <input
                type="number"
                name="experience"
                required
                placeholder="e.g. 2"
                value={formData.experience}
                onChange={handleChange}
              />
            </div>
          </div>

          {}
          <div className="form-group">
            <label>
              Upload Resume (PDF, DOC, DOCX) <span className="required">*</span>
            </label>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              required
              onChange={handleFileChange}
              className="file-upload-input"
            />
          </div>

          <div className="form-group">
            <label>Short Message / Cover Letter</label>
            <textarea
              name="coverLetter"
              rows="3"
              placeholder="Tell us why you are a good fit..."
              value={formData.coverLetter}
              onChange={handleChange}
            ></textarea>
          </div>

          <button
            type="submit"
            className="btn"
            disabled={submitting}
          >
            {submitting ? "Uploading & Submitting..." : "Submit Application"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default JobApplicationForm;
